import { EventEmitter } from "events"
import pubsubEvent from "./event"
import ConsoleLogger from "../core/common/ConsoleLogger"
import { LogLevels } from "../util/eventTypes"
class BaseEvent extends EventEmitter {
  constructor() {
    super()
    this.interceptor = () => {}
    this.$logger = new ConsoleLogger("ocfe")
    this.eventEmitter = pubsubEvent // center event bus
    this.setMaxListeners(100)
    this.env = "web"
    this.sessionId = `${new Date().getTime()}`
    this.$logger.setLevel(this.$logger.Levels.VERBOSE)
  }
  /**
   * broadcast event throught center event bus
   *
   * @param   {any[]}  args
   */
  broadcast(...args) {
    this.eventEmitter.emit(...args)
  }
  /**
   * receive event from center event bus
   *
   * @param   {any[]}  args
   */
  receive(...args) {
    this.eventEmitter.on(...args)
  }
  // remote logging (sensorsdata)
  rlog(...args) {
    this.eventEmitter.emit(LogLevels.INFO, ...args)
  }
  rwarn(...args) {
    this.eventEmitter.emit(LogLevels.WARNING, ...args)
  }
  rerror(...args) {
    this.eventEmitter.emit(LogLevels.ERROR, ...args)
  }
  // console logging
  debug(title, ...args) {
    this.$logger.debug(title, ...args)
  }
  log(title, ...args) {
    this.$logger.log(title, ...args)
  }
  info(title, ...args) {
    this.$logger.info(title, ...args)
  }
  warn(title, ...args) {
    this.$logger.warn(title, ...args)
  }
  error(title, ...args) {
    this.$logger.error(title, ...args)
  }
  fatal(title, ...args) {
    this.$logger.fatal(title, ...args)
  }
}
export default BaseEvent
